import { useKeyPress } from 'src/hooks/useKeyPress';

export const useListenForEscapeKeyPressed = (): boolean => {
  return useKeyPress('Escape');
};
